var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sale-running" }, [
    _c("p", { staticClass: "font-bold text-size-24 text-center" }, [
      _vm._v("本セールの募集は終了しました")
    ]),
    _vm._v(" "),
    _vm.sale.hasEntry
      ? _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: {
              click: function($event) {
                _vm.handleDownload()
              }
            }
          },
          [
            _vm._v("\n    応募した商品情報をダウンロード\n    "),
            _c("i", {
              staticClass: "fa fa-download",
              attrs: { "aria-hidden": "true" }
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02fb11a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02fb11a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/sale/components/SaleEntryRunning.vue
// module id = null
// module chunks = 